// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__IJ68g","list":"BalanceDue_list__2iA1h","listRow":"BalanceDue_listRow__12eXX","total":"BalanceDue_total__1Twix"};